<template>
  <div>
    <v-card-title class="text-body-1 black--text">
      <span class="grey--text">Items per page</span>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            dark
            text
            color="primary"
            class="ml-2"
            v-bind="attrs"
            v-on="on"
          >
            {{ itemsPerPage }}
            <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(number, index) in itemsPerPageArray"
            :key="index"
            @click="updateItemsPerPage(number)"
          >
            <v-list-item-title>{{ number }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-spacer></v-spacer>

      <span class="mr-4 grey--text">
        Page {{ page }} of {{ numberOfPages }}
      </span>
      <v-btn
        fab
        :disabled="page === 1"
        elevation="0"
        small
        color="primary"
        class="mr-1"
        @click="formerPage"
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-btn
        fab
        :disabled="page === numberOfPages"
        elevation="0"
        small
        color="primary"
        class="ml-1"
        @click="nextPage"
      >
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-card-title>
    <v-data-iterator
      :page.sync="page"
      :items="iteratorItems"
      :items-per-page.sync="itemsPerPage"
      hide-default-footer
    >
      <template v-slot:default="props">
        <template v-for="item in props.items">
          <v-divider :key="item.name + '_divider'"></v-divider>
          <list-item
            :item="item"
            :key="item.name"
            :reports="reports"
            :disable-report="disableReport"
            @toggle-report="data => $emit('toggle-report', data)"
          ></list-item>
        </template>
      </template>
      <template v-slot:no-data>
        <v-list-item class="py-4 text-center rounded grey lighten-4 mx-4 mb-4">
          <v-list-item-content>
            <i class="grey--text darken-3">-- No Results Found --</i>
          </v-list-item-content>
        </v-list-item>
      </template>
      <template v-slot:no-results>
        <v-list-item class="py-4 text-center rounded grey lighten-4 mx-4 mb-4">
          <v-list-item-content>
            <i class="grey--text darken-3">-- No Results Found --</i>
          </v-list-item-content>
        </v-list-item>
      </template>
      <template v-slot:footer>
        <v-divider></v-divider>
        <v-card-title class="text-body-1 black--text">
          <span class="grey--text">Items per page</span>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                dark
                text
                color="primary"
                class="ml-2"
                v-bind="attrs"
                v-on="on"
              >
                {{ itemsPerPage }}
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(number, index) in itemsPerPageArray"
                :key="index"
                @click="updateItemsPerPage(number)"
              >
                <v-list-item-title>{{ number }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-spacer></v-spacer>

          <span class="mr-4 grey--text">
            Page {{ page }} of {{ numberOfPages }}
          </span>
          <v-btn
            fab
            :disabled="page === 1"
            elevation="0"
            small
            color="primary"
            class="mr-1"
            @click="formerPage"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn
            fab
            :disabled="page === numberOfPages"
            elevation="0"
            small
            color="primary"
            class="ml-1"
            @click="nextPage"
          >
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-card-title>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
import ListItem from "./Results.ResponseRate.ListItem.vue";

export default {
  components: { ListItem },
  props: {
    items: Array,
    search: String,
    reports: Object,
    disableReport: Function
  },
  data: () => ({
    itemsPerPageArray: [5, 10, 25, 50, 100],
    page: 1,
    itemsPerPage: 25
  }),
  computed: {
    iteratorItems() {
      let results = [];

      let filtered = this.items.filter(
        x => x.children && x.children.length > 0
      );

      for (let i = 0; i < filtered.length; i++) {
        if (simpleSearch(this.search, filtered[i])) results.push(filtered[i]);
      }
              
      return results;

      function simpleSearch(term, obj) {
        if (obj.name.toLowerCase().indexOf(term.toLowerCase()) > -1)
          return true;

        if (obj.children) {
          for (let i = 0; i < obj.children.length; i++) {
            if (simpleSearch(term, obj.children[i])) return true;
          }
        }

        return false;
      }
    },
    numberOfPages() {
      return Math.ceil(this.iteratorItems.length / this.itemsPerPage);
    }
  },
  methods: {
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
    }
  }
};
</script>
